import {
    ListItem,
    ListItemButton,
    ListItemProps,
    ListItemButtonProps,
    SxProps,
} from '@mui/material';

import { withSxProp } from 'common/utils/props';

interface IProps {
    button?: boolean;
    sx?: SxProps;
    isLast?: boolean;
    disableHover?: boolean;
}

const listFooterStyle: SxProps = {
    py: {
        xs: 2,
    },
    px: {
        xs: 2,
        sm: 4,
    },
    borderTop: '1px solid',
    borderColor: 'divider',
    '&:hover': {
        textDecoration: 'none',
    },
};

export function ListFooter<C extends React.ElementType>({
    sx,
    button,
    isLast,
    disableHover,
    ...other
}: IProps & Partial<ListItemProps<C>> & Partial<ListItemButtonProps<C>>) {
    const sxProps = [
        listFooterStyle,
        isLast && {
            mb: {
                xs: -1,
                sm: -2,
            },
        },
        disableHover && {
            cursor: 'default',
            '&:hover': {
                backgroundColor: 'transparent',
            },
        },
        ...withSxProp(sx),
    ];

    if (button) {
        return <ListItemButton {...other} sx={sxProps} />;
    }

    return <ListItem {...other} sx={sxProps} />;
}
